/**
 * Decode HTML entities in text
 *
 * Common HTML entities that will be decoded:
 * - &#39; or &apos; -> '
 * - &quot; -> "
 * - &amp; -> &
 * - &lt; -> <
 * - &gt; -> >
 * - &nbsp; -> space
 * - &#8217; -> '
 * - &#8220; -> "
 * - &#8221; -> "
 * - &#8211; -> –
 * - &#8212; -> —
 */
export function decodeHtmlEntities(text: string | null | undefined): string {
  if (!text) return '';

  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
}

/**
 * Check if text contains HTML entities
 */
export function hasHtmlEntities(text: string | null | undefined): boolean {
  if (!text) return false;

  // Common HTML entity patterns
  const htmlEntityRegex = /&[#a-zA-Z0-9]+;/;
  return htmlEntityRegex.test(text);
}
